const theme = {
  background: '#ffffff',
  textPrimary: '#2D354C',
  textSecondary: '#2D354C',
  buttonPrimary: '#5a4fff',
  buttonGhost: 'transparent',
};

export default theme;
